export default "__VITE_ASSET__BceVBDDH__"